import $ from 'jquery';

var LegalInfo = (function () {
  'use strict';

  var $publishBtn = $('.js__publish');
  var $draftBtn = $('.js__draft');
  var $draftCheckBox = $('.js__is-draft');

  var init = function () {
    $publishBtn.on('click', function () {
      $('.js__confirm-publish-modal')
        .modal({
          closable: false,
          onShow: function () {
            $('.js__submit-form-btn').on('click', function () {
              $draftCheckBox.prop('checked', true);
              $publishBtn.parents('form').submit();
              $publishBtn.parent().find('button').prop('disabled', true);
            });
          },
        })
        .modal('show');
    });

    $draftBtn.on('click', function () {
      $draftCheckBox.prop('checked', false);
      $(this).parents('form').submit();
      $(this).parent().find('button').prop('disabled', true);
    });
  };

  return {
    init: init,
  };
})();

export default LegalInfo;
